import {CToken} from '../function/axios'
import globalCookies from '../function/cookies'
import ACCOUNT_API from './account'
export let cancelInitCart;
export let cancelCheckToken;
export let cancelAddToExisting;

export default {
  initCart: (items) => {
    return window.ccpAxios.post('/api/cart/create',{
      items
    },{
      cancelToken : new CToken(function (c){
        cancelInitCart = c
      })
    })
  },
  checkToken: (token,fullValidation = false) => {
    const access_token = globalCookies.get("access_token")
    if(access_token){
      ACCOUNT_API.setAccessToken(access_token)
    }
    return window.ccpAxios.get(`/api/cart/${token}${fullValidation?'':'?partial_validation=true'}`,{
      cancelToken: new CToken (function(c){
        cancelCheckToken = c
      })
    })
  },
  addToExisting: (items,token) => {
    return window.ccpAxios.post(`/api/cart/${token}/item/add`,{
      items
    },{
      cancelToken : new CToken(function (c){
        cancelAddToExisting = c
      })
    })
  },
  updateItem: (token,uuid,item) => {
    return window.ccpAxios.put(`/api/cart/${token}/item/${uuid}/edit`,{
      ...item
    })
  },
  deleteItem: (token,uuid) =>{
    return window.ccpAxios.delete(`/api/cart/${token}/item/${uuid}`)
  },
  addPromo: (code,token) =>{
    return window.ccpAxios.post(`/api/cart/${token}/promo/add`,{
        promo: code
    })
  },
  removePromo: (code,token) =>{
    return window.ccpAxios.delete(`/api/cart/${token}/promo/${code}`)
  },
  clearCart: (token) => {
    return window.ccpAxios.delete(`/api/cart/${token}`)
  },
  bulkAction: (token,items) =>{
    const payload = {
      items
    }
    return window.ccpAxios.post(`/api/cart/${token}/items/process`,payload)
  }
}